import Projects from '../../DAL/Projects'
import Sites from '../../DAL/Sites'
import {makeSiteAddress, assembleProject} from '.'
import { doc, setDoc } from 'firebase/firestore'

export default async function projectsOne(fields, allowCreateProject= false) {
  const projRef = doc(new Projects().baseQuery)
  const siteRef = doc(new Sites().baseQuery)

  try {
    const {geocode_results = {}, latitude, longitude, restrict_schedule} = fields
    const {siteAddress = ``, dummyAddress = ``, sameRep = false, sameAddress = false} = fields
    const {siteOwnerName = ``, siteRepName = ``, siteRepEmail = ``, siteRepPhone = ``} = fields
    const {client, projectType, inspector, inspectorType = null, installer = {id: ``, name: ``}, rubric = null, organization, formRubrics} = fields

    let site = {
      geocode_results,
      siteAddress,
      sameAddress,
      siteRepName,
      siteRepEmail,
      siteRepPhone,
      sameRep,
      siteOwnerName,
      id: siteRef.id,
    }

    site = await makeSiteAddress({
      site,
      siteAddress,
      dummyAddress,
      latitude,
      longitude,
    })

    await setDoc(siteRef, site)

    await assembleProject({
      organization,
      client,
      installer,
      site,
      projectType,
      inspector,
      inspectorType,
      rubric,
      projRef,
      restrict_schedule: !!restrict_schedule, // convert
      formRubrics,
      allowCreateProject,
    })

    return projRef.id
  } catch (e) {
    console.log(`an error occurred while saving a single project to the database: `, e)
    throw e
  }
}
